import { COUPON_TYPE } from "../../constants";
import { useAppState } from "../../context";
import { UserType } from "../../types";
import { useState, useEffect } from "react";
export const AccountCoupons = () => {
    const [user] = useAppState<UserType>('user');
    const [copiedId, setCopiedId] = useState<number | null>(null);
    const [canCopy, setCanCopy] = useState(false);

    useEffect(() => {
        if ('clipboard' in navigator) {
            setCanCopy(true);
            document.body.classList.add('cancopy');
        }
    }, []);

    const handleCopy = async (code: string, id: number) => {
        if (!document.body.classList.contains('holdcopy')) {
            try {
                await navigator.clipboard.writeText(code);
                document.body.classList.add('holdcopy');
                setCopiedId(id);

                setTimeout(() => {
                    document.body.classList.remove('holdcopy');
                    setCopiedId(null);
                }, 1500);
            } catch (error) {
                console.error('Failed to copy:', error);
            }
        }
    };

    return (
        <>
            <h1 className="section__title">
                Your Active Coupons
            </h1>

            <div className="coupons">
                {user?.coupons?.length ? (
                    user.coupons.map(coupon => (
                        <div className="coupons__item coupon" key={coupon.id}>
                            <div className="coupon__id">
                                {coupon.code}
                            </div>
                            <div className="coupon__discount">
                                {coupon.type == COUPON_TYPE.ONE_TIME_FREE_CLIP ? (
                                    'Free story'
                                ) : (
                                    `-${coupon.percent}%`
                                )}
                            </div>
                            {canCopy && <button 
                                className={`btn btn_cta btn_lg btn_extrapad js_copy ${copiedId === coupon.id ? 'm-copy-success' : ''}`}
                                onClick={() => handleCopy(coupon.code, coupon.id)}
                            >
                                <span className="js_copy_text">
                                    {copiedId === coupon.id ? 'Copied' : 'Copy'}
                                </span>
                            </button>}
                        </div>
                    ))
                ) : (
                    <div className="coupons__item coupon">
                        <p>No coupons available at the moment.</p>
                    </div>
                )}
            </div>
        </>
    );
};

export default AccountCoupons; 